<template>
  <b-card no-body class="mb-2 shadow-sm border-0 ai-card no-data-card" role="region" :aria-label="`${title}: no data to compare`">
    <div class="card-body p-3">
      <div class="d-flex align-items-center mb-2">
        <b-icon-info-circle class="mr-2 text-muted" font-scale="1.1" aria-hidden="true" />
        <h6 class="m-0 font-weight-bold text-uppercase" style="font-size: 13px;">{{ title }}</h6>
      </div>
      <p class="small text-muted mb-0">No data to compare.</p>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'NoDataCompareCard',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.no-data-card {
  border-left: 4px solid #adb5bd !important;
}
</style>
